export const parseBreadcrumbs = (breadcrumb, dictionary, locale) => {
  const dictionaryMatch = dictionary.flat[breadcrumb[0]]
  const parsedBreadcrumbs = []

  if (dictionaryMatch && dictionaryMatch.length > 0) {
    for (const bc of dictionaryMatch) {
      parsedBreadcrumbs.push({
        slug: `${bc}`,
        label: dictionary.labelsObj[bc][parseLocale(locale)],
      })
    }
  }

  return parsedBreadcrumbs.reverse()
}

export const parseBreadcrumbsRelatedCategories = (
  breadcrumbs,
  dictionary,
  locale
) => {
  const offset = breadcrumbs?.length === 3 ? 2 : 1
  const parentCategory = breadcrumbs[breadcrumbs.length - offset]
  const breadcrumbsFlat = Object.values(dictionary?.flat)

  if (breadcrumbsFlat) {
    const matchedCategories = breadcrumbsFlat.filter(
      (breadcrumb) =>
        breadcrumb.includes(parentCategory?.slug) &&
        breadcrumb.length > breadcrumbs.length
    )
    if (matchedCategories?.length) {
      return parseRelatedCategories(
        matchedCategories,
        breadcrumbs?.length,
        dictionary,
        locale
      )
    }
  }
}

const parseRelatedCategories = (
  matchedCategories,
  level,
  dictionary,
  locale
) => {
  const parsedCategories = []
  for (const cat of matchedCategories) {
    if (cat?.length === level + 1) {
      const matchedCat = cat?.[0]
      parsedCategories.push({
        slug: `${matchedCat}`,
        label: dictionary?.labelsObj?.[matchedCat]?.[parseLocale(locale)],
      })
    }
  }
  return parsedCategories
}

const parseLocale = (locale) => {
  return locale === 'fr' ? 'fr_CA' : 'en_US'
}
